import React from "react";
import { motion } from "framer-motion";
import { TrendingUp, Shield, Globe2, Rocket } from "lucide-react";
import { Card, CardContent } from "../ui/card";

export default function WhyNow() {
  const reasons = [
    {
      icon: TrendingUp,
      title: "Budgets are surging",
      description: "NATO projects all Allies at ≥2% of GDP in 2025 (≈US$1.6T today) with a path to ≥3.5% for core defence by 2035 within a broader 5% defence & security pledge—implying spend rising toward ~US$2.8–4.0T.",
      color: "#24A19C"
    },
    {
      icon: Shield,
      title: "Europe is rearming",
      description: "EU defence outlays reached €343B in 2024 and are expected to approach ~€392B in 2025, marking a historic acceleration in European defence investment.",
      color: "#E0B422"
    },
    {
      icon: Rocket,
      title: "Ukraine’s Defense Opportunity",
      description: "Ukraine’s young defence industry combines rapid innovation, real battlefield experience, and strong demand for capital — offering exceptional potential for NATO-country JVs seeking agile, combat-tested partners.",
      color: "#24A19C"
    },
    {
      icon: Globe2,
      title: "Global tailwinds",
      description: "Taiwan targets ~5% of GDP by 2030; Philippines advancing ~US$35B Re-Horizon 3 program; Vietnam forecast ~5-6% CAGR to 2029; Africa reached US$52.1B in 2024.",
      color: "#E0B422"
    }
  ];

  return (
    <div className="bg-[#F5F7FA] py-24">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-[#2C3E50] mb-6">
            The Defence Moment
          </h2>
          <p className="text-xl text-[#6B7C93] max-w-3xl mx-auto">
            Europe is entering a historic defense moment — with record rearmament, rising global conflicts, and Ukraine-driven innovation creating unprecedented demand and budgets for dual-use, military, and safety technologies that are now rapidly scaling worldwide.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6">
          {reasons.map((reason, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
            >
              <Card className="bg-white border-none shadow-lg hover:shadow-xl transition-all duration-300 h-full">
                <CardContent className="p-8">
                  <div className="flex items-start gap-4">
                    <div 
                      className="p-4 rounded-xl"
                      style={{ backgroundColor: `${reason.color}15` }}
                    >
                      <reason.icon className="w-8 h-8" style={{ color: reason.color }} />
                    </div>
                    <div className="flex-1">
                      <h3 className="text-xl font-bold text-[#2C3E50] mb-3">
                        {reason.title}
                      </h3>
                      <p className="text-[#6B7C93] leading-relaxed">
                        {reason.description}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}